export default __webpack_public_path__ + "static/media/grafema_clivitalbio_17.e1e5f59b.jpg";